module.exports = __webpack_public_path__ + "images/Bubbles_ForestFruits_1.png";